import { render } from "./mvt-feed.vue?vue&type=template&id=11901e85"
import script from "./mvt-feed.js?vue&type=script&lang=js"
export * from "./mvt-feed.js?vue&type=script&lang=js"

import "./mvt-feed.vue?vue&type=style&index=0&id=11901e85&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__